import * as core from '../../../../../../../core'
import * as changeImpactRank from '../change-impact-rank'

export const RESOURCE = {
  payload: {
    description: 'High',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactRank.RESOURCE.payload.partialId,
    }),
    id: 'High',
    name: 'High',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
